<template>
    <div class="text-segment" :class="[segmentData.style ? `${segmentData.style}-style` : null]" ref="text-segment">
        <div v-if="segmentData.style === 'tip'" class="text-segment__header">
            <ProIcon icon="sparkle" />
            {{ $t("global.pro_tip") }}
        </div>
        <div v-if="segmentData.style === 'heads-up'" class="text-segment__header">
            <ProIcon icon="wave" />
            {{ $t("global.heads_up") }}
        </div>
        <markdown :markdown="segmentData.content" />
    </div>
</template>

<script>
import Markdown from "~/components/handbook/Markdown";
import tippy from "tippy.js";

export default {
    inheritAttrs: false,
    components: { Markdown },
    props: {
        segmentData: Object,
        label: String,
        displayOnly: Boolean,
        id: String,
    },

    mounted() {
        let glossaries = this.$refs["text-segment"].querySelectorAll(".glossary");

        for (let glossary of glossaries) {
            tippy(glossary, {
                content: "<h2>" + glossary.dataset.title + '</h2><div class="gloss-content">' + glossary.dataset.content + "</div>",
                interactive: true,
                allowHTML: true,
                placement: "top",
                trigger: "click",
            });
        }
    },
};
</script>
